"use strict";
import { List, Map } from "immutable";
import CacheableEffects from "../../util/pine/cacheable_effects";
const isEffect = (object) => Map.isMap(object) && object.get("__type__") === "Effect";
const effect = (...parameters) => {
  const address = _.initial(parameters);
  const task = _.last(parameters);
  return Map({
    __type__: "Effect",
    task,
    address
  });
};
const ignore = ([model, effects]) => model;
const perform = (mailbox, effect2) => {
  effect2.getIn(["task", "perform"])(mailbox.fromAddress(effect2.get("address")));
  return true;
};
const canBeMapped = (effect2) => isEffect(effect2) || CacheableEffects.isCacheableEffect(effect2);
const map = (...parameters) => {
  const address = _.initial(parameters);
  const effects = _.last(parameters);
  return effects.map((effect2) => {
    if (canBeMapped(effect2)) {
      return effect2.set("address", address.concat([effect2.get("address")]));
    } else {
      return effect2;
    }
  });
};
const Effects = (...parameters) => List.of(...parameters);
Effects.isEffect = isEffect;
Effects.effect = effect;
Effects.none = List();
Effects.map = map;
Effects.ignore = ignore;
Effects.perform = perform;
Effects.cacheableEffect = CacheableEffects.effect;
export default Effects;
